import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Input,
    OnInit,
    Output,
    EventEmitter,
    ViewEncapsulation
} from '@angular/core';
import { BaseComponent } from 'src/app/_core/tools/base.component';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import get from 'lodash-es/get';
import {BehaviorSubject, Observable, throwError} from 'rxjs';
import {
    GroupePubliGroupeOrdreModel,
    MutationGetListeChampsByGroupeAffichageArgs,
    PubliChampsGroupeAffichageModel
} from 'src/graphql/generated-types';
import { arrayNotEmpty } from 'src/app/utils/array.utils';
import { GraphqlService } from 'src/app/_core/services/graphql.service';
import gql from 'graphql-tag';

interface TagsPublipostage {
    Ordre: number;
    LibelleGroupe: string;
    ListeChamps: {
        anyType: ListeChampsTagPublipostage;
    }[];
}

interface ListeChampsTagPublipostage {
    attributes: {
        'z:Id': string;
        'i:type': string;
    };
    CodeChamps: string;
    DescriptionChamps: string;
    IdChamps: number;
    IsRequired: false;
    IsSelected: false;
    LibelleChamps: string;
    TagChamp: string;
}

@Component({
    selector: 'app-shared-mail-publipostage-tags',
    templateUrl: './shared-mail-publipostage-tags.component.html',
    styleUrls: ['./shared-mail-publipostage-tags.component.sass'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SharedMailPublipostageTagsComponent extends BaseComponent implements OnInit {

    filterPublipostageForm: UntypedFormGroup;

    displayedTagsList: ListeChampsTagPublipostage[] = [];

    tagsList: TagsPublipostage[] = [];

    private _publipostageTypeId = new BehaviorSubject<number>(null);

    @Input()
    set publipostageTypeId(publipostageTypeId: number) {
        this._publipostageTypeId.next(publipostageTypeId);
    }

    get publipostageTypeId(): number {
        return this._publipostageTypeId.getValue();
    }

    get publipostageTypeId$(): Observable<number> {
        return this._publipostageTypeId.asObservable();
    }

    constructor(protected readonly cdr: ChangeDetectorRef,
                private readonly fb: UntypedFormBuilder,
                private readonly graphqlService: GraphqlService) {
        super(cdr);
    }

    setDragItem($event: any, tag: ListeChampsTagPublipostage) {
        $event.dataTransfer.setData('text', '[[' + tag.TagChamp + ']]');
    }

    private getTagsList(): Observable<(PubliChampsGroupeAffichageModel | GroupePubliGroupeOrdreModel)[]> {
        this.loading = true;

        return this.graphqlService.mutateOne<'GetListeChampsByGroupeAffichage', MutationGetListeChampsByGroupeAffichageArgs>({
            mutation: gql`
                mutation GetListeChampsByGroupeAffichage($contexte: ContextInfosInput, $criteres: ChampsCriteresPubliModeleModelInput) {
                    GetListeChampsByGroupeAffichage(
                        contexte: $contexte
                        criteres: $criteres
                    ) {
                        PubliChampsGroupeAffichageModel {
                            ...on PubliChampsGroupeAffichageModel {
                                Ordre
                                LibelleGroupe
                                ListeChamps {
                                    anyType
                                }
                            }
                        }
                    }
                }`,
            variables: {
                criteres: {
                    IdTypePubli: this.publipostageTypeId,
                }
            }
        }).pipe(
            map(GetListeChampsByGroupeAffichage => {
                const groupsList = (GetListeChampsByGroupeAffichage?.PubliChampsGroupeAffichageModel || []) as TagsPublipostage[];
                this.tagsList = groupsList.filter(group => arrayNotEmpty(get(group, ['ListeChamps', 'anyType']))) || [];
                this.loading = false;

                this.filterPublipostageForm.get('tag').patchValue(this.tagsList[0]?.LibelleGroupe || null);

                return this.tagsList;
            }),
            catchError(err => {
                this.loading = false;
                return throwError(err);
            })
        );
    }

    ngOnInit(): void {
        this.watch$ = this.publipostageTypeId$.pipe(
            switchMap(() => this.getTagsList())
        );

        this.filterPublipostageForm = this.fb.group({
            search: [null],
            tag: [null]
        });

        this.watch$ = this.filterPublipostageForm.valueChanges.pipe(
            tap(value => {
                const filteredTags: ListeChampsTagPublipostage[] = get(this.tagsList.find(e => e.LibelleGroupe === value.tag), ['ListeChamps', 'anyType'], []);
                this.displayedTagsList = filteredTags.filter(e => !value.search || e.LibelleChamps.toLocaleLowerCase().indexOf(value.search.toLocaleLowerCase()) > -1);
            })
        );
    }

}
